import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Loading from "@/components/Loading";
import "./index.less";
import { getIconUrl, notUseJoySpaceOffline } from "../../util";
import ShareIcon from "../List/ShareIcon";
import { changeEgovUrl } from "@/utils/tools";
import IconFont from "@/components/icon";
import Tags, { TagType } from "../Tags";
import { ContextMenuMode, OpenFolderStatus } from "../../types";
import { Dropdown, message, Tooltip } from "antd";
import { doDrag } from "@/components/Joyspace/components/MoveDragger";
import GlobalContext from "@/context/GlobalContext";
import events from "../../context/events";
interface IProps {
  list: any[];
  callback?: Function;
  loading?: boolean;
  isLoadMore?: boolean;
  canDrag?: string;
  title?: string;
  renderActions?: (item: any, contextMenuMode?: ContextMenuMode) => React.ReactElement;
  openFolder?: Function;
  renderDesc?: Function;
  maxFolderNum?: number;
  onButtom?: Function;
  emptyText?: string;
  isCollectedShow?: boolean;
  allowDraggble?: boolean;
}

export default function CardList(props: IProps) {
  const {
    list,
    title,
    loading = true,
    isLoadMore = false,
    callback,
    renderActions,
    renderDesc,
    onButtom,
    emptyText = "",
    isCollectedShow = false,
    allowDraggble = false
  } = props;
  const [visible, setVisible] = useState(false);
  const { onLine } = useContext(GlobalContext);
  const [newItem, setNewItem] = useState<any>({});
  const hideContextMenus = useCallback(() => {
    setVisible(false);
  }, []);
  useEffect(() => {
    events.on("hideContextMenus", hideContextMenus);
    return () => {
      events.off("hideContextMenus", hideContextMenus);
    };
  }, [hideContextMenus]);
  const classNames = useMemo(() => {
    let classNames = "card-item";
    if (allowDraggble) {
      classNames += " draggble";
    }
    return classNames;
  }, [allowDraggble]);
  const onContextMenu = useCallback(
    (event) => {
      if (!onLine || !list.length) {
        return;
      }
      events.emit("hideContextMenus");
      if (event?.target) {
        const attr = (event.target as any).getAttribute("data-menu");
        if (attr === "contextMenu") {
          return;
        }
      }
      events.emit("list.check");
      setVisible(true);
    },
    [list.length, onLine]
  );
  return (
    <div className="joyspace-card-box">
      <h3 className="joyspace-card-header">{title}</h3>
      {!loading && list.length > 0 && (
        <Dropdown
          overlay={() => {
            return renderActions?.(newItem, ContextMenuMode.ContextMenu) || <span />;
          }}
          visible={visible}
          trigger={["contextMenu"]}
          getPopupContainer={() => {
            const node =
              (document.getElementsByClassName(
                "joyspace-card-ppup-container"
              )?.[0] as HTMLElement) || document.body;
            return node;
          }}
        >
          <div data-menu="contextMenu" className="joyspace-card-list" onContextMenu={onContextMenu}>
            {list.map((item: any) => {
              item.disabledItem = onLine ? false : !item.isDBExist;
              return (
                <div
                  className={
                    visible && newItem?.id === item.id ? `${classNames} card-item-bc` : classNames
                  }
                  key={item.id}
                  onClick={(e: any) => {
                    callback?.(e, item);
                  }}
                  onContextMenu={() => {
                    setNewItem(item);
                  }}
                  data-drag={item.isFolder ? item.id : "stop"}
                  onDragStart={(e) => {
                    if (!allowDraggble) {
                      message.info("当前位置不支持拖拽");
                      e.preventDefault();
                      return;
                    }
                    const dragImage =
                      // @ts-ignore
                      e.target?.querySelector?.(".card-item-drag") || e.target;
                    doDrag({ dragItem: item, e, dragImage, dragFrom: "card" });
                  }}
                  draggable
                >
                  {!item.isFolder && item.disabledItem && <div className="card-item-disable" />}
                  <div className="card-item-drag crad-item-c">
                    {item.isFolder ? (
                      <ShareIcon isShared={item.isShared} imgUrl={item.imgUrl} />
                    ) : (
                      <img
                        src={
                          item.disabledItem ? getIconUrl(item.pageType) : changeEgovUrl(item.imgUrl)
                        }
                      />
                    )}
                    <div
                      className={
                        !item.isFolder && item.disabledItem
                          ? "crad-item-c crad-item-c-disable"
                          : "crad-item-c"
                      }
                    >
                      <div className="crad-item-title">
                        <Tooltip placement="topLeft" title={item.title}>
                          <a href="javascript:void(0)">{item.title}</a>
                        </Tooltip>
                        <span className="crad-item-tags">
                          {isCollectedShow && item.isCollected && (
                            <Tags left={5} TagType={TagType.Follow} />
                          )}
                          {item.open === OpenFolderStatus.OPEN && (
                            <Tags left={5} TagType={TagType.Open} />
                          )}
                          {/* <Tags left={5} TagType={TagType.Open} /> */}
                        </span>
                      </div>
                      {renderDesc?.(item)}
                    </div>
                  </div>
                  <div className="card-item-r">{renderActions?.(item)}</div>
                </div>
              );
            })}
            {isLoadMore && (
              <div
                className="card-item card-item-more"
                onContextMenu={(event: any) => {
                  event.stopPropagation();
                }}
                onClick={() => {
                  onButtom?.();
                }}
              >
                <span>查看更多</span>
                <IconFont className="more-icon" type="iconpc_ic_zhankai_doc" />
              </div>
            )}
          </div>
        </Dropdown>
      )}
      {loading && !list.length && (
        <div className="joyspace-list-table-not-data">
          <div className="list-table-loading">
            <Loading />
          </div>
        </div>
      )}
      {/* {!loading && isLoadMore && list.length > 0 && (
                <div className="joyspace-list-table-not-data">
                    <div className="joyspace-list-more">
                        <LoadMoreLoading />
                        <span style={{ whiteSpace: 'nowrap' }}>加载更多</span>
                    </div>
                </div>
            )} */}
      {!loading && !list.length && (
        <div className="joyspace-cardlist-not-data">
          {notUseJoySpaceOffline() || onLine ? (
            <p>{emptyText || "暂无数据"}</p>
          ) : (
            <p>暂无缓存信息，请联网后查看</p>
          )}
        </div>
      )}
    </div>
  );
}
